

module.exports = __webpack_require__.stylable.create(
    "stylablehorizontalmenu1177387379",
    {"classes":{"root":"stylablehorizontalmenu1177387379__root","menu":"stylablehorizontalmenu1177387379__menu","menuItem":"stylablehorizontalmenu1177387379__menuItem","scrollButton":"stylablehorizontalmenu1177387379__scrollButton","columnsLayout":"stylablehorizontalmenu1177387379__columnsLayout","leftAlignmentScrollItem":"stylablehorizontalmenu1177387379__leftAlignmentScrollItem","rightAlignmentScrollItem":"stylablehorizontalmenu1177387379__rightAlignmentScrollItem","listItem":"stylablehorizontalmenu1177387379__listItem","positionBox":"stylablehorizontalmenu1177387379__positionBox"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    3,
    45,
    null
);
